  $(document).ready(function(){
    $(".titleN").click(function(){
        var dataId = $(this).attr("data-id");
        $(".para").each(function(){	
        var id=$(this).attr("id");
        if(dataId == id){
          $(this).siblings('.titleN').toggleClass('iconss');
          $(this).slideToggle();
          // $(this).siblings('.titleN button span').css('transform','rotate(-45deg)');
        }else{
          $(this).siblings('.titleN').removeClass('iconss');
          $(this).slideUp();
        }
        });
    });
  });


 $(document).ready(function() {
    var $cartDrawer = $('#cart');
    // Open cart drawer on add to cart
    $(document).on('click', '.quick-view-bottom .barracuda-cart-addToCartButton', function(event) {
      // $cartDrawer.addClass('control-visible visible');
      setTimeout(() => {
        barracudaCart.refreshCart();
        openTopbar(event,'cart');
        // $('.barracuda-cart-opener.icon-cart').click();
      },2000);
    });
  });



document.addEventListener('DOMContentLoaded', function (){

  // ------------------------------------------ Variant change ------------------------------------------

  
    const addToCardBtn = document.querySelector('.barracuda-cart-addToCartButton');

      // Set correct button state on page load based on the checked swatch
    (function initButtonState() {
      const checkedSwatch = document.querySelector('.main_select_option:checked');
      if (checkedSwatch && addToCardBtn) {
        const variantAvailable = checkedSwatch.dataset.variantAvailable;
        if (variantAvailable === 'soldout') {
          addToCardBtn.classList.add('disabled');
          addToCardBtn.innerText = 'Sold out';
          const dynamicButtons = document.querySelector('.dynamic-buy');
          if (dynamicButtons) dynamicButtons.classList.add('hidden');
        } else if (variantAvailable === 'available') {
          addToCardBtn.classList.remove('disabled');
          const dynamicButtons = document.querySelector('.dynamic-buy');
          if (dynamicButtons) dynamicButtons.classList.remove('hidden');
        }
      }
    })();

    document.addEventListener('change', (e) => {
    let hiddenVariantSelect = document.querySelector('.itgVariantSelect select');
     if (e.target.closest('.main_select_option')) {
        const selectedValue = e.target.value;
        const subtitleText = e.target.dataset.substitle;
        const subtitleColor = e.target.dataset.subsbackcolor;
        const variantAvailable = e.target.dataset.variantAvailable;
        const subsTitle = document.querySelector('.subscription_banner');
       let matchFound = false;
       let notBlank = false;

        document.querySelectorAll('.Wrap_option').forEach((option) => {
          if (option.dataset.option === selectedValue) {
              matchFound = true;
              if (subtitleText) {
                notBlank = true;
              } 

            subsTitle.classList.contains('hidden') && subsTitle.classList.remove('hidden');
            option.classList.add('active');
             
            if (subsTitle && subtitleText) {
              subsTitle.innerText = subtitleText;
              subsTitle.style.backgroundColor = subtitleColor;
              subsTitle.style.minHeight = 'auto';
            }
            if(addToCardBtn && variantAvailable == 'available') {
              addToCardBtn.classList.remove('disabled');
              addToCardBtn.innerText = 'Add to cart'
            }
          } else {
            option.classList.remove('active');
            subsTitle.classList.add('hidden');

             if(addToCardBtn && variantAvailable == 'soldout') {
              addToCardBtn.classList.add('disabled');
              addToCardBtn.innerText = 'Sold out'
            }
          }
        });

        if (matchFound) {
          subsTitle?.classList.remove('hidden');
        } else {
          subsTitle?.classList.add('hidden');
        }

        if (!notBlank && subsTitle) {
          subsTitle.innerText = '';
          subsTitle.style.minHeight = '20px';
        }

        let variantValue = '';
        let variants = document.querySelectorAll('.main_select_option:checked');
        let i = 1;
        variants.forEach((variant) => {
          if(variants.length == i){
            variantValue += variant.value;
          } else {
            variantValue += variant.value + ' / ';
          }
          i++;
        });
      
       let options = Array.from(hiddenVariantSelect.options);
        options.forEach((option) => {
          let optionValue = option.innerText.trim();
          console.log(optionValue, variantValue,optionValue == variantValue)
          if (optionValue == variantValue) {
            option.selected = true;
            ogPrice = option.dataset.ogprice;
            compPrice = option.dataset.compprice;
            document.querySelector('.product-price span.price.variant-data').innerText = ogPrice;
            option.click();
            // Update ?variant= in the URL so third-party apps (e.g. KBite) can detect the selected variant
            if (history.replaceState) {
              var variantId = option.value;
              var separator = window.location.search.indexOf('variant=') !== -1 ? '' : (window.location.search ? '&' : '?');
              var newUrl = window.location.href.replace(/([?&])variant=\d+/, '$1variant=' + variantId);
              if (newUrl === window.location.href) newUrl = window.location.href.split('#')[0] + separator + 'variant=' + variantId;
              history.replaceState({ path: newUrl }, '', newUrl);
            }
            if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
              const productForm = document.querySelector("[bss-b2b-main-product-form]");
              BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
            }
          }
        });
      }
    });













  // ------------------------------------------ Save and Subscription option ------------------------------------------


   setTimeout(() => {
   function saveAndSub() {
      document.querySelectorAll('.purchase--option')?.forEach(option => {
        option.addEventListener('change', function() {
            let selectedPlan = document.querySelector('.Wrap_option.active  .purchase--option:checked').value;
            document.querySelector('#selling_plan_input').value = selectedPlan;
            if(document.querySelector('.product__subs__group.subscription_plane input.purchase--option:checked')){
              let selectedPlanBlock = document.querySelector('.Wrap_option.active .delivery_content select .block:checked').value;
              document.querySelector('#selling_plan_input').value = selectedPlanBlock;
           }
        });
      });
     
     
      document.querySelectorAll('.delivery_content select').forEach(select => {
          select?.addEventListener('change', function (){
           if(document.querySelector('.product__subs__group.subscription_plane input.purchase--option:checked')){
              let selectedPlanBlock = this.querySelector('.block:checked').value;
              document.querySelector('#selling_plan_input').value = selectedPlanBlock;
           }
        });
      })
   }
      function  purchaseClick() {
        document.querySelector('.Wrap_option.active .purchase--option')?.click();
      }
     setTimeout(() => {
      purchaseClick();
    },1000);
    
    document.addEventListener('click',(e) => {
      if(e.target.closest('.swatch-element')){
        setTimeout(() => {
          purchaseClick();
        },200);
      }
    });
    saveAndSub();
    document.addEventListener('click', (e) => {
      if(e.target.closest('.with-quick-view .icon-add-to-cart')){
        setTimeout(() => {
          saveAndSub();
          purchaseClick();
        },1000);
      }
    });
  },100);
  // ----------------------------------------------------------------------------------------------------------------
  // function saveAndSub() {
  //    document.querySelector('.purchase--option')?.click();
  //   document.querySelectorAll('.purchase--option')?.forEach(option => {
  //     option.addEventListener('change', function() {
  //         let selectedPlan = document.querySelector('.purchase--option:checked').value;
  //         document.getElementById('selling_plan_input').value = selectedPlan;
  //         if(document.querySelector('.product__subs__group.subscription_plane input.purchase--option:checked')){
  //           let selectedPlanBlock = document.querySelector('.deliver-select .block:checked').value;
  //           document.getElementById('selling_plan_input').value = selectedPlanBlock;
  //        }
  //     });
  //   });
  //   document.querySelector('.deliver-select')?.addEventListener('change', function (){
  //      if(document.querySelector('.product__subs__group.subscription_plane input.purchase--option:checked')){
  //         let selectedPlanBlock = this.querySelector('.block:checked').value;
  //         document.getElementById('selling_plan_input').value = selectedPlanBlock;
  //      }
  //   });
  // }
  // saveAndSub();
  // document.addEventListener('click', (e) => {
  //   if(e.target.closest('.with-quick-view .icon-add-to-cart')){
  //     setTimeout(() => {
  //       saveAndSub();
  //     },1000);
  //   }
  // });


  
 document.addEventListener('click', function(event) {
    const cartDrawer = document.querySelector('.main-cart.barracuda-cart-target');
    const controlVisible = document.querySelector('.control-visible');

    if (cartDrawer && !event.target.closest('.control-visible')) {
       // closeTopbar(event);
      document.querySelector('#cart .icon.icon-x').click();
    }
  });
});



